var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDepositOnline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4389_2230)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "url(#paint0_linear_4389_2230)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9279 5.33398H21.0719C22.308 5.33398 22.9261 5.33398 23.4246 5.50743C24.3698 5.83634 25.1119 6.60032 25.4314 7.57341C25.5999 8.08657 25.5999 8.72284 25.5999 9.99538V24.9331C25.5999 25.8486 24.5492 26.3343 23.8846 25.7261C23.4941 25.3688 22.9057 25.3688 22.5152 25.7261L21.9999 26.1976C21.3155 26.8239 20.2843 26.8239 19.5999 26.1976C18.9155 25.5714 17.8843 25.5714 17.1999 26.1976C16.5155 26.8239 15.4843 26.8239 14.7999 26.1976C14.1155 25.5714 13.0843 25.5714 12.3999 26.1976C11.7155 26.8239 10.6843 26.8239 9.9999 26.1976L9.4846 25.7261C9.09412 25.3688 8.50569 25.3688 8.11521 25.7261C7.45057 26.3343 6.3999 25.8486 6.3999 24.9331V9.99538C6.3999 8.72284 6.3999 8.08657 6.56839 7.57341C6.88788 6.60032 7.63 5.83634 8.57525 5.50743C9.07372 5.33398 9.69179 5.33398 10.9279 5.33398ZM19.2633 12.2668C19.5576 11.9372 19.529 11.4315 19.1994 11.1372C18.8698 10.843 18.3641 10.8716 18.0698 11.2012L14.857 14.7995L13.93 13.7612C13.6357 13.4316 13.13 13.403 12.8004 13.6972C12.4708 13.9915 12.4422 14.4972 12.7365 14.8268L14.2603 16.5335C14.4121 16.7035 14.6292 16.8007 14.857 16.8007C15.0849 16.8007 15.302 16.7035 15.4538 16.5335L19.2633 12.2668ZM11.1999 18.934C10.7581 18.934 10.3999 19.2922 10.3999 19.734C10.3999 20.1758 10.7581 20.534 11.1999 20.534H20.7999C21.2417 20.534 21.5999 20.1758 21.5999 19.734C21.5999 19.2922 21.2417 18.934 20.7999 18.934H11.1999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4389_2230",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F6932B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16601"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4389_2230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDepositOnline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DepositOnline.2237268c.svg";
export { ForwardRef as ReactComponent };